import React from 'react'
import { type AccountSummarySavedCardItem } from '@assets/mockdata/PatientTray/mockAccountSummary'
import PatientProfileAccountBadge from './PatientProfileAccountBadge.component'
import {
  AccountDeleteButton,
  AccountSetDefaultButton,
} from './PatientProfilePaymentMethodItemCard.component'

type PatientProfileSavedCardItemCardProps = {
  item: AccountSummarySavedCardItem
  onDelete: () => void
  onSetDefault: () => void
  setDefaultDisabled?: boolean
  readOnly?: boolean
}

function PatientProfileSavedCardItemCard({
  item,
  onDelete,
  onSetDefault,
  setDefaultDisabled,
  readOnly = false,
}: PatientProfileSavedCardItemCardProps): React.ReactElement {
  const title = `Card ending in ${item.lastFour}`

  return (
    <article className="patient-profile-account-item">
      <div className="patient-profile-account-item-head">
        <h4 className="patient-profile-account-item-title">{title}</h4>
        {item.badge === 'default' ? (
          <PatientProfileAccountBadge isDefault />
        ) : (
          <AccountSetDefaultButton
            label={`Set ${title} as default`}
            onClick={onSetDefault}
            disabled={readOnly || setDefaultDisabled}
          />
        )}
      </div>
      <div
        className={`patient-profile-account-item-field${
          readOnly ? '' : ' patient-profile-account-item-field--with-action'
        }`}
      >
        <div className="patient-profile-account-item-field-main">
          <span className="patient-profile-account-item-field-label">
            Card:
          </span>
          <span className="patient-profile-account-item-field-value patient-profile-account-item-field-value--regular">
            {item.brand}
          </span>
        </div>
        {!readOnly ? (
          <AccountDeleteButton label={`Remove ${title}`} onClick={onDelete} />
        ) : null}
      </div>
    </article>
  )
}

export default PatientProfileSavedCardItemCard
